import React, { type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Flex, Text, Toggle } from 'mailup-web-components'

import {
  modalSubscribeChangeCallback,
  modalSubscribeToggleFieldCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalSubscribe'

import { modalSubscribeState } from 'Pages/RecipientsList/recoil/state/modalSubscribe'

const StyledLabel = styled(Text)`
  cursor: pointer;
`

const InputSelectAllLists: FC = () => {
  const intl = useIntl()

  const { allLists } = useRecoilValue(modalSubscribeState)

  const toggleField = useRecoilCallback(modalSubscribeToggleFieldCallback, [])
  const change = useRecoilCallback(modalSubscribeChangeCallback, [])

  const handleToggle = (): void => {
    void change({ listsIsDirty: true })
    void toggleField('allLists')
  }

  return (
    <Flex alignItems="center" gap="8px">
      <Toggle
        data-mu-test="input-all-lists-toggle"
        variant="sm"
        checked={allLists}
        onChange={handleToggle}
        id="all-lists-toggle"
      />
      <StyledLabel htmlElement="label" htmlFor="all-lists-toggle">
        {intl.formatMessage({
          id: 'Load.RecipientsList.ModalSubscribeSelectAllLists',
        })}
      </StyledLabel>
    </Flex>
  )
}

export default InputSelectAllLists
